'use client';

import React, { FC, useState } from 'react';
import { useGetStories } from '@/common/queries/baseInfo';
import BottomSheet from '@/components/BottomSheet';
import { HintSlider } from './components/HintSlider';
import { InfoSheet } from './components/InfoSheet';
import { useGetRouteStoryData } from './hooks/useGetRouteStoryData';

interface IHintBottomSheetProps {
  shouldOpenFullPage: boolean;
  id?: string | undefined;
  isChangelog?: boolean;
  highlightNumber?: number;
}

const HintBottomSheet: FC<IHintBottomSheetProps> = ({
  shouldOpenFullPage,
  id,
  isChangelog = false,
  highlightNumber,
}) => {
  const { labels } = useGetRouteStoryData(isChangelog);

  const { data, isLoading, refetch } = useGetStories({
    page: labels,
  });

  const webStories = data?.filter((item) =>
    item?.storyPages?.find(
      (storyPage) =>
        labels?.includes(storyPage?.tagID) &&
        ['web', 'All'].includes(storyPage?.device)
    )
  );

  const [sliderId, setSliderId] = useState<string | null>(null);
  const chosenStory = webStories?.find((item) => item?.id === id);
  const chosenSlide =
    chosenStory?.slides?.find((item) => item?.id === sliderId) ||
    chosenStory?.slides?.[0];
  const shouldShowHintSlider = shouldOpenFullPage && chosenStory && chosenSlide;

  return shouldShowHintSlider ? (
    <HintSlider
      chosenSlide={chosenSlide}
      chosenStory={chosenStory}
      highlightNumber={highlightNumber}
      isChangelog={isChangelog}
      refetchStories={refetch}
      setSliderId={setSliderId}
    />
  ) : (
    <InfoSheet isLoading={isLoading} items={webStories || []} />
  );
};

export const openHintBottomSheet = ({
  shouldOpenFullPage,
  id,
  isChangelog,
  highlightNumber,
}: IHintBottomSheetProps) =>
  BottomSheet.open({
    children: (
      <HintBottomSheet
        highlightNumber={highlightNumber}
        id={id}
        isChangelog={isChangelog}
        shouldOpenFullPage={shouldOpenFullPage}
      />
    ),
    classNames: {
      overlay: '!z-[9] ',
      sheet: shouldOpenFullPage ? '!p-0 h-full !rounded-none' : '!p-0',
    },
  });

export default openHintBottomSheet;
